import { useEffect } from 'react';
import { X } from 'lucide-react';

export default function Modal({ title, onClose, children, wide = false, testid }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 md:p-8" role="dialog" aria-modal="true" aria-label={title} data-testid={testid}>
      <div className="absolute inset-0 bg-[var(--mm-purple-dark)]/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative bg-white rounded-2xl w-full ${wide ? 'max-w-5xl' : 'max-w-3xl'} max-h-[90vh] flex flex-col overflow-hidden shadow-[0_40px_80px_-30px_rgba(46,8,56,.6)]`}>
        <div className="flex items-start justify-between gap-4 px-5 md:px-7 py-4 border-b border-[var(--mm-line)]">
          <h3 className="font-display text-lg font-bold text-[var(--mm-ink)] pr-2 leading-snug">{title}</h3>
          <button onClick={onClose} autoFocus data-testid="modal-close-btn" aria-label="Close"
            className="shrink-0 w-9 h-9 rounded-full border border-[var(--mm-line)] flex items-center justify-center text-[var(--mm-ink)]/70 hover:border-[var(--mm-purple)] hover:text-[var(--mm-purple)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--mm-purple)]">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
